import { createAndRedirectToNewApp, buildAppUrl } from '../../../common/components/utility';

export class AppBuilder {
    store = null;

    async init({ store }) {
        this.store = store;
        await this._initActions();
    }

    async _initActions() {
        const enterAppBuilderButton: HTMLButtonElement = document.querySelector('.app-builder-action-control');

        if (enterAppBuilderButton !== null) {        
            enterAppBuilderButton.addEventListener('click', async (event) => {
                const createAndRedirectToNewAppOptions = {
                    store: this.store
                }

                await createAndRedirectToNewApp(createAndRedirectToNewAppOptions);
            })
        }
    }
}